$('.card-product').hover(
    function() {
        $(this).find('.custom-shop-button').addClass('active');
    },
    function() {
        $(this).find('.custom-shop-button').removeClass('active');
    }
);

// const $checkbox = $('#customize_picker_YwyDnx-1');

// // Store original value
// const originalValue = $checkbox.val();

// $checkbox.on('change', function () {
//   if ($(this).is(':checked')) {

//     // Get PDT time only
//     const time = new Date().toLocaleTimeString('en-US', {
//       timeZone: 'America/Los_Angeles',
//       hour: '2-digit',
//       minute: '2-digit',
//       second: '2-digit',
//       hour12: true
//     });

//     // Append timestamp
//     $(this).val(`${originalValue} at ${time} PDT`);

//   } else {
//     // Restore original value when unchecked
//     $(this).val(originalValue);
//   }
// });